import { useFrame } from '@react-three/fiber';
import { useRef } from 'react';
import { Raycaster, Scene, Vector3 } from 'three';

interface UseRaycastParameters {
  source?: Vector3;
  direction?: Vector3;
  containerName?: string;
}

const useRaycast = (
  onPositionFound: (point: Vector3) => void,
  {
    source = new Vector3(0, 200, 0),
    direction = new Vector3(0, -1, 0),
    containerName = 'tilesContainer',
  }: UseRaycastParameters
) => {
  const raycasterRef = useRef<Raycaster>(new Raycaster());
  const positionRef = useRef<Vector3 | undefined>(undefined!);

  useFrame(({ scene }) => {
    if (positionRef.current) return;
    const position = getDesiredPosition(scene);
    positionRef.current = position;

    if (!position) return;
    onPositionFound(position);
  });

  const getDesiredPosition = (scene: Scene) => {
    raycasterRef.current.near = 1;
    raycasterRef.current.far = 500;
    raycasterRef.current.set(source, direction);

    const tilesContainer = scene.getObjectByName(containerName)!;
    const intersections = raycasterRef.current.intersectObjects(
      tilesContainer.children,
      true
    );
    if (!intersections.length) return;

    const position = intersections[0].point;
    return position;
  };
};

export default useRaycast;
